module.exports = __webpack_public_path__ + "static/media/6 Seats 6 Sides Rollarm (disconnected).bd8a4d51.png";